<template>
  <!-- 合同续签申请 -->
  <div>
    <Collapse v-model="value2" simple :disabled="prevent" style="border:0">
      <Panel name="1" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.basicInformation : enName.basicInformation
          "
        />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          class="titleDistance"
          :disabled="prevent"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.serialnumber : enName.serialnumber
                "
              >
                <Input
                  :disabled="isHistory"
                  placeholder=""
                  v-model="formItem.serialnumber"
                >
                  <Button
                    slot="append"
                    icon="ios-search"
                    :disabled="isHistory"
                    @click="select"
                  ></Button>
                </Input>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.userName : enName.userName"
              >
                <Input disabled v-model="formItem.userName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.positionName : enName.positionName
                "
              >
                <Input disabled v-model="formItem.positionName" />
              </FormItem>
            </Col>
          </Row>
          <!-- <Row type="flex" justify="space-between">
                <Col :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem :label="lang=='zh'?chName.orgsname2:enName.orgsname2">
                     <Input disabled v-model="formItem.orgsname2"/>
                  </FormItem>
                </Col>                
                <Col :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem :label="lang=='zh'?chName.orgsname4:enName.orgsname4">
                     <Input disabled v-model="formItem.orgsname4"/>
                  </FormItem>
                </Col>
                <Col :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem :label="lang=='zh'?chName.orgsname5:enName.orgsname5">
                    <Input disabled v-model="formItem.orgsname5"/>
                  </FormItem>
                </Col>
            </Row> -->
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.hirevalid : enName.hirevalid"
              >
                <Date-picker
                  v-model="formItem.hirevalid"
                  disabled
                  type="date"
                  placeholder=""
                  style="width: 100%;"
                ></Date-picker>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.Contract_renewal : enName.Contract_renewal
          "
        />
        <Tabs
          :animated="true"
          class="titleDistance"
          slot="content"
          :disabled="prevent"
        >
          <Tab-pane
            :label="
              lang == 'zh' ? chName.contract_resume : enName.contract_resume
            "
            style="width:100%"
          >
            <Row>
              <Col span="23">
                <Table border :columns="columns1" :data="RecordData"></Table>
              </Col>
            </Row>
            <Row>
              <Col
                span="23"
                style="margin-top:20px;display: flex;justify-content: flex-end;"
              >
                <Page :total="total1" @on-change="pageChange1" />
              </Col>
            </Row>
          </Tab-pane>
        </Tabs>
      </Panel>
      <Panel name="3" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.renewaldecision : enName.renewaldecision
          "
        />
        <Form
          :label-width="120"
          slot="content"
          label-position="left"
          class="titleDistance"
          :disabled="prevent"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.contractype : enName.contractype"
              >
                <Select
                  v-model="contractFormItem.contracttype"
                  :clearable="true"
                  placeholder=""
                  :disabled="isHistory"
                  @on-change="getEndDate"
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in contractTypeList"
                    :key="i"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.contractnumber : enName.contractnumber
                "
              >
                <Input
                  :disabled="isHistory"
                  v-model="contractFormItem.contractnumber"
                />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.filelocation : enName.filelocation
                "
              >
                <Input
                  :disabled="isHistory"
                  v-model="contractFormItem.filelocation"
                />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.newbegindate : enName.newbegindate
                "
              >
                <Date-picker
                  v-model="contractFormItem.begindate"
                  :disabled="begindateDisabled"
                  type="date"
                  placeholder=""
                  style="width: 100%"
                  @on-change="getEndDate"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.period : enName.period">
                <Row>
                  <Col span="5"
                    ><Input
                      :disabled="isHistory"
                      v-model="contractFormItem.yearlimit"/></Col
                  >{{ lang == "zh" ? chName.year : enName.year }}
                  <Col span="5"
                    ><Input
                      :disabled="isHistory"
                      v-model="contractFormItem.monthlimit"/></Col
                  >{{ lang == "zh" ? chName.month : enName.month }}
                  <Col span="5"
                    ><Input
                      :disabled="isHistory"
                      v-model="contractFormItem.daylimit"/></Col
                  >{{ lang == "zh" ? chName.day : enName.day }}
                </Row>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.newenddate : enName.newenddate"
              >
                <Date-picker
                  v-model="contractFormItem.enddate"
                  :disabled="isHistory || enddateDisabled"
                  :readonly="isReadonly"
                  type="date"
                  placeholder=""
                  style="width: 100%"
                  @on-change="timeChange"
                ></Date-picker>
                <Checkbox v-model="contractFormItem.isNoEndContract" disabled>{{
                  lang == "zh" ? chName.isNoEndContract : enName.isNoEndContract
                }}</Checkbox>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="24">
              <FormItem
                span="3"
                :label="lang == 'zh' ? chName.comment : enName.comment"
              >
                <Input
                  type="textarea"
                  v-model="contractFormItem.comment"
                  :disabled="isHistory"
                />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label-width="150"
                :label="lang == 'zh' ? chName.completion : enName.completion"
              >
                <Checkbox
                  v-model="contractFormItem.completion"
                  :disabled="isHistory"
                ></Checkbox>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label-width="150"
                :label="
                  lang == 'zh' ? chName.approvebylabor : enName.approvebylabor
                "
              >
                <Checkbox
                  v-model="contractFormItem.approvebylabor"
                  :disabled="isHistory"
                ></Checkbox>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label-width="150"
                :label="lang == 'zh' ? chName.paypenalty : enName.paypenalty"
              >
                <Checkbox
                  v-model="contractFormItem.paypenalty"
                  :disabled="isHistory"
                ></Checkbox>
              </FormItem>
            </Col>
          </Row>
          <!-- <Row>
              <Col span="24">
                <FormItem :label="$t('附件')">
                  <j2-FileUP ref="file2" :disabled="isHistory" @handleDel="fileDel" @handleOK="fileSuc" :file_type="{resourceType:'Contract_Attachment'}" :resourceId="formItem.attachment"></j2-FileUP>
                </FormItem>
              </Col>
            </Row> -->
        </Form>
      </Panel>
      <!-- 审批历史 -->
      <Panel
        name="4"
        hide-arrow
        style="margin-bottom: 20px;border:0"
        v-if="isHistory"
      >
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.approvalhistory : enName.approvalhistory
          "
          style="margin-top: 30px"
        />
        <Table
          border
          :columns="columns3"
          :data="data3"
          class="titleDistance"
          slot="content"
        >
        </Table>
      </Panel>
    </Collapse>
    <Row class="btnRight">
      <Col>
        <!-- EA -->
        <Button class="applyBtnRight" @click="QAClick">QA</Button>
        <Button class="applyBtnRight" v-if="!isHistory" @click="importCG"
          >导入草稿</Button
        >
        <Button class="applyBtnRight" v-if="!isHistory" @click="saveCG"
          >保存草稿</Button
        >
        <Button class="applyBtnRight" v-if="!isHistory" @click="submitt">{{
          lang == "zh" ? chName.submit : enName.submit
        }}</Button>
        <Button
          class="applyBtnRight"
          @click="exportContract"
          v-if="isHistory && formItem.status == '8'"
          >{{
            lang == "zh" ? chName.exportcontract : enName.exportcontract
          }}</Button
        >
        <Button class="applyBtnRight" @click="returnPage">{{
          lang == "zh" ? chName.return : enName.return
        }}</Button>
      </Col>
    </Row>

    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1" />
    <j2-DraftPop ref="cgPop" />
    <!-- 弹框 选择员工 -->
    <Modal
      v-model="empoloyee"
      :title="lang == 'zh' ? chName.selectemployee : enName.selectemployee"
      width="860px"
    >
      <!-- <div >{{lang=='zh'?chName.isNoEndContract:enName.isNoEndContract}}</div> -->
      <Form :model="filter" inline :label-width="120" label-position="left">
        <FormItem
          :label="lang == 'zh' ? chName.serialnumber : enName.serialnumber"
          :label-width="120"
        >
          <Input
            type="text"
            v-model="filter.serialnumber"
            placeholder=""
            style="width: 150px"
          ></Input>
        </FormItem>
        <FormItem
          :label="lang == 'zh' ? chName.userName : enName.userName"
          :label-width="130"
        >
          <Input
            type="text"
            v-model="filter.userName"
            placeholder=""
            style="width: 150px"
          ></Input>
        </FormItem>
        <Button
          type="primary"
          @click="(total = 0), (pageInfo.pageNum = 1), getp()"
          >{{ lang == "zh" ? chName.search : enName.search }}</Button
        >
      </Form>
      <Table
        ref="myTable"
        :loading="prevent"
        :columns="columns2"
        :data="data2"
        border
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="select1(row, index)"
            >{{ lang == "zh" ? chName.select : enName.select }}</Button
          >
        </template>
      </Table>
      <div style="margin-top:10px">
        <!-- <div></div> -->
        <Page :total="total" @on-change="pageChange" />
      </div>
      <div slot="footer">
        <Button type="text" @click="handleCancle">{{
          lang == "zh" ? chName.cancel : enName.cancel
        }}</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <QAComponent ref="qaComponent" @QAData="QAData"></QAComponent>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
import QAComponent from "@/components/process/Apply/components/QAComponent";
export default {
  components: { QAComponent },
  data() {
    return {
      date: new DateUtil(),
      value2: [1, 2, 3, 4],
      formItem: {
        status: ""
      },
      contractFormItem: {},
      filter: {},
      chName: {},
      enName: {},
      empoloyee: false,
      prevent: false,
      RecordData: [],
      data2: [],
      data3: [],
      contractTypeList: [],
      isHistory: false,
      isReadonly: false,
      spinShow: false,
      pageInfo: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      pageInfo1: {
        itemCount1: 0,
        pageNum1: 1,
        pageSize1: 10
      },
      total1: 0,
      enddateDisabled: false,
      begindateDisabled: true,
      qaId: ""
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns1() {
      return [
        {
          title:
            this.lang == "zh"
              ? this.chName.contractnumber
              : this.enName.contractnumber,
          key: "contractnumber",
          align: "center",
          width: "200"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.contractype
              : this.enName.contractype,
          key: "contracttype",
          align: "center",
          width: "200",
          render: (h, params) => {
            var name = "-";
            this.contractTypeList
              ? this.contractTypeList.map((item, index) => {
                  if (item.code == params.row.contracttype) {
                    name = item.name;
                  }
                })
              : "";
            return h("span", name);
          }
        },
        {
          title:
            this.lang == "zh" ? this.chName.begindate : this.enName.begindate,
          key: "begindate",
          align: "center",
          width: "200",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.begindate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.lang == "zh" ? this.chName.enddate : this.enName.enddate,
          key: "enddate",
          align: "center",
          width: "200",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.enddate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.lang == "zh" ? this.chName.period : this.enName.period,
          key: "contractPeriod",
          align: "center",
          width: "200"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.filelocation
              : this.enName.filelocation,
          key: "filelocation",
          align: "center",
          width: "490"
        }
      ];
    },
    columns2() {
      return [
        {
          title: this.lang == "zh" ? this.chName.action : this.enName.action,
          slot: "action",
          align: "center",
          width: "150"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.serialnumber
              : this.enName.serialnumber,
          key: "serialnumber",
          align: "center",
          width: "150"
        },
        {
          title:
            this.lang == "zh" ? this.chName.userName : this.enName.userName,
          key: "userName",
          align: "center",
          width: "150"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.contractbegindate
              : this.enName.contractbegindate,
          key: "begindate",
          align: "center",
          width: "170",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.begindate, "YYYY-MM-DD")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.contractenddate
              : this.enName.contractenddate,
          key: "enddate",
          align: "center",
          width: "150",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.enddate, "YYYY-MM-DD")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.positionName
              : this.enName.positionName,
          key: "positionName",
          align: "center",
          width: "150"
        }
      ];
    },
    columns3() {
      return [
        {
          title:
            this.lang == "zh" ? this.chName.stepName : this.enName.stepName,
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalperson
              : this.enName.approvalperson,
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvaltime
              : this.enName.approvaltime,
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalstatus
              : this.enName.approvalstatus,
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalopinions
              : this.enName.approvalopinions,
          key: "message",
          align: "center",
          width: "465"
        }
      ];
    }
  },
  created() {
    // 查询国际化
    this.getInternation();
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
  },
  watch: {
    "contractFormItem.isNoEndContract"(val) {
      if (val == true) {
        this.contractFormItem.enddate = null;
        this.isReadonly = true;
      } else {
        this.isReadonly = false;
      }
    },
    "contractFormItem.paypenalty"(val) {
      console.log(val, "paypenalty");
    },
    "contractFormItem.contracttype"(val) {
      if (val == "OneYear") {
        this.contractFormItem.yearlimit = 1;
        this.contractFormItem.monthlimit = 0;
        this.contractFormItem.daylimit = 0;
        this.contractFormItem.isNoEndContract = false;
        this.contractFormItem.enddate = this.date.addDays(
          this.date.addYears(this.contractFormItem.begindate, 1, "YYYY-MM-DD"),
          -1,
          "YYYY-MM-DD"
        );
        this.enddateDisabled = false;
      } else if (val == "TwoYear") {
        this.contractFormItem.yearlimit = 2;
        this.contractFormItem.monthlimit = 0;
        this.contractFormItem.daylimit = 0;
        this.contractFormItem.isNoEndContract = false;
        this.contractFormItem.enddate = this.date.addDays(
          this.date.addYears(this.contractFormItem.begindate, 2, "YYYY-MM-DD"),
          -1,
          "YYYY-MM-DD"
        );
        this.enddateDisabled = false;
      } else if (val == "ThreeYear") {
        this.contractFormItem.yearlimit = 3;
        this.contractFormItem.monthlimit = 0;
        this.contractFormItem.daylimit = 0;
        this.contractFormItem.isNoEndContract = false;
        this.contractFormItem.enddate = this.date.addDays(
          this.date.addYears(this.contractFormItem.begindate, 3, "YYYY-MM-DD"),
          -1,
          "YYYY-MM-DD"
        );
        this.enddateDisabled = false;
      } else if (val == "Unlimit") {
        this.contractFormItem.yearlimit = "";
        this.contractFormItem.monthlimit = "";
        this.contractFormItem.daylimit = "";
        this.contractFormItem.isNoEndContract = true;
        this.contractFormItem.enddate = "";
        this.enddateDisabled = true;
      }
    }
  },
  mounted() {
    this.getListDate();
  },
  methods: {
    getEndDate() {
      if (
        this.contractFormItem.begindate &&
        this.contractFormItem.contracttype
      ) {
        if (this.contractFormItem.contracttype == "OneYear") {
          this.contractFormItem.enddate = this.date.addDays(
            this.date.addYears(
              this.contractFormItem.begindate,
              1,
              "YYYY-MM-DD"
            ),
            -1,
            "YYYY-MM-DD"
          );
        } else if (this.contractFormItem.contracttype == "TwoYear") {
          this.contractFormItem.enddate = this.date.addDays(
            this.date.addYears(
              this.contractFormItem.begindate,
              2,
              "YYYY-MM-DD"
            ),
            -1,
            "YYYY-MM-DD"
          );
        } else if (this.contractFormItem.contracttype == "ThreeYear") {
          this.contractFormItem.enddate = this.date.addDays(
            this.date.addYears(
              this.contractFormItem.begindate,
              3,
              "YYYY-MM-DD"
            ),
            -1,
            "YYYY-MM-DD"
          );
        } else if (this.contractFormItem.contracttype == "Unlimit") {
          this.contractFormItem.enddate = "";
        }
        this.$forceUpdate();
      }
    },
    //打开草稿列表
    importCG() {
      this.$refs.cgTem.getInternation();
      //草稿type 操作人
      this.$refs.cgTem.popShow(
        "CR01",
        JSON.parse(sessionStorage.getItem("userInfo")).userId
      );
    },
    //保存草稿
    saveCG() {
      this.$refs.cgPop.getInternation();
      //草稿type 草稿内容
      // this.formItem.attachment_name = this.$refs.file2.fileName
      this.formItem.hirevalid = this.date.dateVal(
        this.formItem.hirevalid,
        "YYYY-MM-DD"
      );
      this.contractFormItem.begindate = this.date.dateVal(
        this.contractFormItem.begindate,
        "YYYY-MM-DD"
      );
      this.contractFormItem.enddate = this.date.dateVal(
        this.contractFormItem.enddate,
        "YYYY-MM-DD"
      );
      this.$refs.cgPop.popShow("CR01", {
        formItem: this.formItem,
        contractFormItem: this.contractFormItem,
        RecordData: this.RecordData
      });
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      this.getp();
      var obj = JSON.parse(row.draftContent);
      this.formItem = obj.formItem;
      this.contractFormItem = obj.contractFormItem;
      this.RecordData = obj.RecordData;
      let i = 0;
      if (this.RecordData[i]) {
        this.RecordData[i].number = i + 1;
        this.RecordData[i].enddate = this.date.dateVal(
          new Date(this.RecordData[i].enddate),
          "YYYY-MM-DD"
        );
        this.RecordData[i].begindate = this.date.dateVal(
          new Date(this.RecordData[i].begindate),
          "YYYY-MM-DD"
        );
      }
      // this.$nextTick(() => {
      //   this.$refs.file2.resource_id = this.formItem.attachment
      //   this.$refs.file2.fileName = this.formItem.attachment_name
      // })
    },
    getInternation() {
      let Obj = {
        viewType: "Contract_Renew",
        beUsed: "1"
      };
      this.spinShow = true;
      axios.post("/International/applySelectViewSet", Obj).then(res => {
        console.log(res);
        this.chName = res.data[0];
        this.enName = res.data[1];
        // console.log(this.chName)
        this.spinShow = false;
      });
    },
    exportContract() {
      this.spinShow = true;
      let arr = {
        objData1: { instanceId: this.getQueryVariable("instanceId") }
      };

      axios.post("/wordExport/downloadWord", arr).then(res => {
        this.spinShow = false;
        let fileName = res.dataMap.docName;
        let URL = this.dataURLtoBlob(res.data);
        var reader = new FileReader();
        reader.readAsDataURL(URL);
        reader.onload = function(e) {
          // 兼容IE
          if (window.navigator.msSaveOrOpenBlob) {
            var bstr = atob(e.target.result.split(",")[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr]);
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            // 转换完成，创建一个a标签用于下载
            const a = document.createElement("a");
            a.download = fileName; // 这里写你的文件名
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        };
      });
    },
    dataURLtoBlob(dataurl) {
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    timeChange(val) {
      let newBeginTime = this.date.addDays(this.contractFormItem.begindate, -1);
      let month1 = this.date.diff(val, newBeginTime, 1);
      let month2 = month1 >= 12 ? month1 % 12 : month1;
      this.contractFormItem.monthlimit = month2;
      let day1 = this.date.addMonths(newBeginTime, month1);
      let day2 = this.date.diff(val, day1);
      this.contractFormItem.daylimit = day2;
      this.contractFormItem.yearlimit = this.date.diff(val, newBeginTime, 0);
      this.$forceUpdate();
    },
    getListDate() {
      let arr = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        serialnumber: this.formItem.serialnumber
      };

      axios
        .post("/contractRenew/selectContractRenewHistoryForm", arr)
        .then(res => {
          if (res) {
            this.RecordData = res;
          }
        });

      if (this.isHistory) {
        let arr1 = {
          instanceId: this.getQueryVariable("instanceId")
        };
        axios
          .post("/contractRenew/selectContractRenewsAllData", arr1)
          .then(res => {
            if (res) {
              this.formItem = res.basicInfo;
              this.formItem.status = res.basicInfo.status;
              this.contractFormItem = res.basicInfo;

              this.$set(
                this.formItem,
                "isNoEndContract",
                this.formItem.isNoEndContract == 1 ? true : false
              );
              this.$set(
                this.formItem,
                "completion",
                this.formItem.completion == 1 ? true : false
              );
              this.$set(
                this.formItem,
                "approvebylabor",
                this.formItem.approvebylabor == 1 ? true : false
              );
              this.$set(
                this.formItem,
                "paypenalty",
                this.formItem.paypenalty == 1 ? true : false
              );

              this.$set(
                this.formItem,
                "serialnumber",
                res.basicInfo.applySerialnumber
              );
              this.$set(this.formItem, "userName", res.basicInfo.applyName);
              this.$set(
                this.formItem,
                "positionName",
                res.basicInfo.applyPositionName
              );
              this.$set(
                this.contractFormItem,
                "begindate",
                res.basicInfo.newContractStartDate
              );
              this.$set(
                this.contractFormItem,
                "enddate",
                res.basicInfo.newContractEndDate
              );
              this.$set(
                this.contractFormItem,
                "comment",
                res.basicInfo.comments
              );
              this.$set(
                this.contractFormItem,
                "contracttype",
                res.basicInfo.contracttype
              );
              this.contractTypeList = res.optionList;
              this.data3 = res.logMap;
            }
            let arr2 = {
              pageNum: this.pageInfo.pageNum,
              pageSize: this.pageInfo.pageSize,
              serialnumber: this.formItem.serialnumber,
              instanceId: this.getQueryVariable("instanceId")
            };
            axios
              .post("/contractRenew/selectContractRenewHistorical", arr2)
              .then(res => {
                if (res) {
                  this.RecordData = res;
                }
              });
          });
      }
    },
    select() {
      this.empoloyee = true;
    },
    select1(row) {
      this.formItem = row;
      this.empoloyee = false;
      if (row.enddate) {
        this.contractFormItem.begindate = row.enddate;
      } else {
        this.begindateDisabled = false;
      }
      this.getListDate();
    },
    pageChange(val) {
      this.pageInfo.pageNum = val;
      this.getp();
    },
    pageChange1(val) {
      this.pageInfo1.pageNum1 = val;
      this.getListDate();
    },
    handleCancle() {
      this.empoloyee = false;
    },
    getp() {
      this.prevent = true;
      let arr = {
        serialnumber: this.filter.serialnumber,
        userName: this.filter.userName,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        optionName: ["CONTRACTTYPE"]
      };

      axios.post("/contractRenew/selectContractRenewsUser", arr).then(res => {
        this.prevent = false;
        if (res) {
          this.data2 = res.data;
          this.contractTypeList = res.optionData.CONTRACTTYPE;
        }
      });
    },
    handle() {
      // this.$set( this.contractFormItem,'completion',this.contractFormItem.completion?1:0)
      // this.$set( this.contractFormItem,'approvebylabor',this.contractFormItem.approvebylabor?1:0)
      // this.$set( this.contractFormItem,'paypenalty',this.contractFormItem.paypenalty?1:0)
      // this.$set( this.contractFormItem,'isNoEndContract',this.contractFormItem.isNoEndContract?1:0)
      let arr = [
        {
          objData1: {
            ...this.formItem,
            contracttype: this.contractFormItem.contracttype,
            contractnumber: this.contractFormItem.contractnumber,
            filelocation: this.contractFormItem.filelocation,
            begindate: this.contractFormItem.begindate,
            yearlimit: this.contractFormItem.yearlimit,
            monthlimit: this.contractFormItem.monthlimit,
            daylimit: this.contractFormItem.daylimit,
            enddate: this.contractFormItem.enddate,
            comment: this.contractFormItem.comment,
            completion: this.contractFormItem.completion == true ? 1 : 0,
            approvebylabor:
              this.contractFormItem.approvebylabor == true ? 1 : 0,
            paypenalty: this.contractFormItem.paypenalty == true ? 1 : 0,
            isNoEndContract:
              this.contractFormItem.isNoEndContract == true ? 1 : 0,
            apply_serialnumber: this.formItem.serialnumber,
            apply_user_id: this.formItem.empCode,
            apply_name: this.formItem.userName,
            apply_position_name: this.formItem.positionName,
            apply_position: this.formItem.positionId,
            comments: this.contractFormItem.comment,
            new_contract_start_date: this.date.dateVal(
              this.contractFormItem.begindate,
              "YYYY-MM-DD"
            ),
            new_contract_end_date: this.date.dateVal(
              this.contractFormItem.enddate,
              "YYYY-MM-DD"
            ),
            contracttype: this.contractFormItem.contracttype,

            agent_apply_user_id: JSON.parse(
              window.sessionStorage.getItem("userInfo")
            ).userId,
            agent_apply_serialnumber: JSON.parse(
              window.sessionStorage.getItem("userInfo")
            ).serialnumber,
            agent_apply_name: JSON.parse(
              window.sessionStorage.getItem("userInfo")
            ).userName,
            agent_apply_position: this.formItem.positionId,
            agent_apply_position_name: this.formItem.positionName,
            be_agent: 0
          },
          stringData1: "CR01",
          stringData4: this.formItem.empCode,
          stringData10: this.contractFormItem.contractnumber,
          type: "B31"
        }
      ];
      this.spinShow = true;
      axios.post("/process/execute", arr).then(res1 => {
        this.RecordData.forEach(item => {
          item.instanceId = res1[0];
        });
        // instanceId: res1[0]
        // serialnumber : this.formItem.serialnumber,
        // empcode : this.formItem.empcode,
        // createUserId : JSON.parse( window.sessionStorage.getItem("userInfo") ).userId,
        // updateUserId : JSON.parse( window.sessionStorage.getItem("userInfo") ).userId,
        axios
          .post("/contractRenew/insertContractRenewHistorical", this.RecordData)
          .then(res1 => {
            this.spinShow = false;
            if (res1) {
              this.$Message.info(this.$t("sbumit_Success"));
              this.$router.push(
                "/479EB7C68FD1C711E1668077E8206CA1/A3FFBEBFDB713E27"
              );
            }
          });
      });
    },
    submitt() {
      this.$Modal.confirm({
        title:
          this.lang == "zh" ? this.chName.suresubmit : this.enName.suresubmit,
        content: "",
        okText: this.lang == "zh" ? this.chName.confirm : this.enName.confirm,
        cancelText: this.lang == "zh" ? this.chName.cancel : this.enName.cancel,
        onOk: () => {
          this.prevent = true;
          this.handle();
        },
        onCancel: () => {}
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    returnPage() {
      if (this.isHistory) {
        this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
      } else {
        this.$router.go(-1);
      }
    },
    QAClick() {
      this.$refs.qaComponent.QAModal = true;
      this.$refs.qaComponent.getUserList();
      this.qaId != "" ? (this.$refs.qaComponent.qaId = this.qaId) : "";
    },
    QAData(val) {
      this.qaId = val;
    }
  }
};
</script>

<style lang="less" scoped>
.titleDistance {
  margin: 20px 20px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/ContractRenewApply.vue